module.exports = __webpack_public_path__ + "assets/img/icon_tabnav_01_def.beaead71.png";